<section id="content" class="animated fadeIn" ng-controller="OrderListController" ng-init="orderInit()" ng-class="loading ? 'loading' : ''">
<div class="row">
    <div class="col-sm-4 col-xl-4">
        <div class="panel panel-tile">
            <div class="panel-body">
                <div class="row pv10">
                    <div class="col-xs-5 ph10"><img src="build/img/pages/clipart0.png" class="img-responsive mauto" alt=""></div>
                    <div class="col-xs-7 pl5">
                        <h6 class="text-muted">ToplamKargo</h6>
                        <h2 class="fs50 mt5 mbn">{{ data.total_order }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-4 col-xl-4">
        <div class="panel panel-tile">
            <div class="panel-body">
                <div class="row pv10">
                    <div class="col-xs-5 ph10"><img src="build/img/pages/clipart1.png" class="img-responsive mauto" alt=""></div>
                    <div class="col-xs-7 pl5">
                        <h6 class="text-muted">Bugün OluşturulanKargo</h6>
                        <h2 class="fs50 mt5 mbn">{{ data.today_order }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-4 col-xl-4">
        <div class="panel panel-tile">
            <div class="panel-body">
                <div class="row pv10">
                    <div class="col-xs-5 ph10"><img src="build/img/pages/clipart2.png" class="img-responsive mauto" alt=""></div>
                    <div class="col-xs-7 pl5">
                        <h6 class="text-muted">Toplam Müşteri</h6>
                        <h2 class="fs50 mt5 mbn">{{ data.total_customer }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
	<div class="col-md-12 allcp-grid">
	    <div class="panel mbn" data-panel-title="false">
            <div class="panel-heading">
                <span class="panel-title">AylıkKargo</span>
            </div>
	        <div class="panel-body pn">
	            <div class="row">
	                <div class="col-md-12 mb10">
						<canvas id="bar" class="chart chart-bar" chart-data="order_chart"
							style="width: 100%; height: 350px; margin: 0 auto"
							chart-labels="labels" chart-legend="true" chart-series="series"
							chart-click="onClick" >
						</canvas> 
	                </div>
	            </div>
	        </div>
	    </div>
	</div>
</div>
</section>